<template>
  <div id="nav" class="no-print">
    <!-- <router-link to="/">Home</router-link> | -->
    <router-link to="/about">About</router-link> |
    <router-link to="/setting">Setting</router-link> |
    <!-- <router-link to="/print">Print</router-link> | -->
    <!-- <router-link to="/feeder/141778">feeder</router-link> | -->
    <router-link to="/feeder-list">feeder list</router-link>
  </div>
  <router-view/>
</template>


<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}



@font-face {
  font-family: VazirFD;
  src: url("./../node_modules/vazir-font/dist/Farsi-Digits/Vazir-Regular-FD.eot");
  src: url("./../node_modules/vazir-font/dist/Farsi-Digits/Vazir-Regular-FD.eot?#iefix")
      format("embedded-opentype"),
    url("./../node_modules/vazir-font/dist/Farsi-Digits/Vazir-Regular-FD.woff2")
      format("woff2"),
    url("./../node_modules/vazir-font/dist/Farsi-Digits/Vazir-Regular-FD.woff")
      format("woff"),
    url("./../node_modules/vazir-font/dist/Farsi-Digits/Vazir-Regular-FD.ttf")
      format("truetype");

  font-weight: normal;
  font-style: normal;
}

*,input, select {
  font-family: "VazirFD", sans-serif;
}

</style>
